import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Heart } from "lucide-react";
import { connect } from "react-redux";
import { fetchAlternativeTools } from "actions/tool";

const isValidUrl = (urlString) => {
    const url = new URL(urlString);
    return url.protocol === "http:" || url.protocol === "https:";
};

const AlternativeTools = ({
    tool,
    alternativeTools,
    fetchAlternativeTools,
}) => {
    useEffect(() => {
        if (tool?.uuid) {
            fetchAlternativeTools(tool.uuid);
        }
    }, [tool?.uuid, fetchAlternativeTools]);

    if (!alternativeTools || alternativeTools.length === 0) {
        return null;
    }

    return (
        <div className="space-y-6 py-8">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-semibold">Alternative Tools</h2>
                <Link
                    to={`/alternative/${tool.name}`}
                    className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1"
                >
                    View All Alternatives
                    <ChevronRight className="h-4 w-4" />
                </Link>
            </div>

            <div className="space-y-2">
                {alternativeTools.map((alt) => (
                    <Link
                        key={alt.uuid}
                        to={`/tool/${alt.name}`}
                        className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer"
                    >
                        <div className="flex items-center gap-3">
                            <img
                                src={
                                    alt.logo_url && isValidUrl(alt.logo_url)
                                        ? alt.logo_url
                                        : alt.thumbnail
                                }
                                alt={alt.name}
                                className="w-10 h-10 rounded-lg object-cover"
                            />
                            <div>
                                <h3 className="font-medium">{alt.name}</h3>
                                <p className="text-sm text-gray-500">
                                    {alt.description}
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <button
                                className="text-gray-500 hover:text-red-500"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                            >
                                <Heart className="h-4 w-4" />
                            </button>
                            <div className="text-blue-600">
                                <ChevronRight className="h-4 w-4" />
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default connect(
    (state) => ({
        alternativeTools: state.tool.alternativeTools,
    }),
    { fetchAlternativeTools }
)(AlternativeTools);
